import { jsx as _jsx } from "react/jsx-runtime";
import { Button, ButtonShape, ButtonVariant, IconAnimation, IconName, IconSize } from '@as/cotopaxi';
import { Box } from '@yonderland/andes-react';
import { useState } from 'react';
export const ProductTileImageIcon = ({ onClick, icon, compact }) => {
    const [turnOnIconAnimation, setTurnOnIconAnimation] = useState(false);
    const handleClick = (e) => {
        onClick === null || onClick === void 0 ? void 0 : onClick();
        setTurnOnIconAnimation(icon === IconName.HEART_EMPTY); // when added to wishlist
        e && e.preventDefault();
        e && e.stopPropagation();
    };
    if (!icon)
        return null;
    return (_jsx(Box, { padding: { base: '2', md: compact ? '2' : '4' }, children: _jsx(Button, { variant: ButtonVariant.INVERSE_ALT, shape: ButtonShape.PILL, onClick: handleClick, icon: {
                name: icon,
                size: IconSize.MAJOR,
                animation: turnOnIconAnimation ? IconAnimation.HEART_PULSE : undefined,
            }, dataQA: "product_tile_image_icon" }) }));
};
